// extracted by mini-css-extract-plugin
export default {"theHeader":"TheHeader_theHeader__rjKlZ","logo":"TheHeader_logo__kfXYx","active":"TheHeader_active__8B9tA","rightHeader":"TheHeader_rightHeader__B7qRv"};